<template>
  <div>
    <v-flex xs12>
      <Typography h2 bold :label="$t('consent approve')" />
    </v-flex>

    <InputSearch
      class="mb-3"
      @clickSearch="onSearch"
      @clearSearch="clearSearch"
      :search="search"
      :placeholder="'ค้นหาเลขสมาชิก / ชื่อสมาชิก / รายการ'"
      :isSearch="isSearch"
    />

    <v-tabs
      v-model="activeTab"
      color="white"
      :slider-color="$vuetify.theme.primary"
      style="font-size: 18px"
    >
      <v-tab style="text-transform: capitalize;" ripple href="#privacy">
        นโยบายความเป็นส่วนตัว
        <span
          style="padding: 4px 8px;border-radius: 50px;background: red;color:white;margin-left:6px;font-size:12px;"
        >{{ privacyData.length }}</span>
      </v-tab>
      <v-tab style="text-transform: capitalize;" ripple href="#project">
        โครงการ
        <span
          style="padding: 4px 8px;border-radius: 50px;background: red;color:white;margin-left:6px;font-size:12px;"
        >{{ projectData.length }}</span>
      </v-tab>
      <v-tab style="text-transform: capitalize;" ripple href="#history">ประวัติ</v-tab>
    </v-tabs>

    <v-layout class="my-5" justify-center v-if="loading">
      <v-progress-circular
        :size="100"
        :width="10"
        indeterminate
        color="primary"
      ></v-progress-circular>
    </v-layout>

    <v-data-table
      key="pending-table"
      v-else-if="activeTab !== 'history'"
      :headers="headers"
      :items="activeData"
      hide-actions
      item-key="rowKey"
      class="elevation-1"
    >
      <template v-slot:headers="props">
        <tr style="background-color: #152d53; color: white">
          <th
            style="background-color: #152d53; color: yellow"
            v-for="header in props.headers"
            :key="header.text"
          >
            {{ header.text }}
          </th>
        </tr>
      </template>
      <template v-slot:items="props">
        <tr class="py-3 depatable">
          <td class="text-xs-left">
            <Typography style="width: 120px" left h5 :label="props.item.memberid || '-'" />
          </td>
          <td class="text-xs-left">
            <Typography style="width: 200px" left h5 :label="props.item.name || props.item.institute_name || '-'" />
          </td>
          <td class="text-xs-left">
            <Typography style="width: 200px" left h5 :label="props.item.itemname || '-'" />
          </td>
          <td class="text-xs-left">
            <Typography style="width: 140px" left h5 :label="requestedValueLabel(props.item.value)" />
          </td>
          <td class="text-xs-left">
            <Typography style="width: 150px" left h5 :label="shotDate(props.item.updated_at) || '-'" />
          </td>
          <td class="text-xs-center">
            <img
              @click="viewReason(props.item.reason)"
              src="/static/img/eye.png"
              alt="ดูเหตุผล"
              class="cursor-5"
              style="height: 20px"
            />
          </td>
          <td class="text-xs-left">
            <div style="display:flex;justify-content: space-between;width: 45px;">
              <img
                @click="
                  modalApprove = true
                  modalItem = props.item
                "
                src="/static/img/success.png"
                alt
                class="cursor-5"
                style="height: 20px"
              />
              <img
                @click="
                  modalReject = true
                  modalItem = props.item
                  rejectReason = ''
                "
                src="/static/img/error.png"
                alt
                class="cursor-5"
                style="height: 20px"
              />
            </div>
          </td>
        </tr>
      </template>
    </v-data-table>

    <v-data-table
      key="history-table"
      v-else
      :headers="historyHeaders"
      :items="activeHistoryData"
      hide-actions
      item-key="rowKey"
      class="elevation-1"
    >
      <template v-slot:headers="props">
        <tr style="background-color: #152d53; color: white">
          <th
            style="background-color: #152d53; color: yellow"
            v-for="header in props.headers"
            :key="header.text"
          >
            {{ header.text }}
          </th>
        </tr>
      </template>
      <template v-slot:items="props">
        <tr class="py-3 depatable">
          <td class="text-xs-left">
            <Typography style="width: 150px" left h5 :label="shotDate(props.item.timestamp) || '-'" />
          </td>
          <td class="text-xs-left">
            <Typography style="width: 120px" left h5 :label="props.item.memberid || '-'" />
          </td>
          <td class="text-xs-left">
            <Typography style="width: 200px" left h5 :label="props.item.membername || '-'" />
          </td>
          <td class="text-xs-left">
            <Typography style="width: 200px" left h5 :label="props.item.type === 'privacy' ? (privacyKeyLabel(props.item.itemname) || '-') : (props.item.itemname || '-')" />
          </td>
          <td class="text-xs-left">
            <Typography
              style="width: 140px"
              left
              h5
              :label="requestedValueLabel(props.item.requestedValue)"
            />
          </td>
          <td class="text-xs-center">
            <img
              @click="viewHistoryReason(props.item)"
              src="/static/img/eye.png"
              alt="ดูเหตุผล"
              class="cursor-5"
              style="height: 20px"
            />
          </td>
          <td class="text-xs-left">
            <Typography
              style="width: 120px"
              left
              h5
              :label="props.item.decision === 'approve' ? 'อนุมัติ' : 'ไม่อนุมัติ'"
            />
          </td>
          <td class="text-xs-left">
            <Typography style="width: 150px" left h5 :label="props.item.adminid || '-'" />
          </td>
          
        </tr>
      </template>
    </v-data-table>

    <div v-if="!loading && activeTab !== 'history' && activeData.length === 0" class="text-xs-center mt-5">
      <Typography h5 label="ไม่มีคำขอที่รออนุมัติ" />
    </div>

    <div v-if="!loading && activeTab === 'history' && activeHistoryData.length === 0" class="text-xs-center mt-5">
      <Typography h5 label="ไม่มีประวัติการพิจารณา" />
    </div>

    <v-dialog v-model="modalApprove" persistent width="400px">
      <v-card style="border-radius: 10px">
        <div class="pa-4">
          <v-icon style="display: flex;justify-content: end" @click="modalApprove = false">close</v-icon>
          <div>
            <Typography center h2 bold label="อนุมัติ" />
          </div>
          <div class="rsu mt-2">
            <v-layout wrap class="mb-3">
              <v-flex xs12>
                <Typography center h5 label="คุณแน่ใจหรือไม่ว่าต้องการอนุมัติคำขอนี้" />
              </v-flex>
            </v-layout>
            <div style="display: flex; justify-content: center">
              <Button :loading="deciding" outline label="ยกเลิก" @click="modalApprove = false" />
              <Button :loading="deciding" depressed label="อนุมัติ" @click="clickDecide('approve')" />
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="modalReject" persistent width="400px">
      <v-card style="border-radius: 10px">
        <div class="pa-4">
          <v-icon style="display: flex;justify-content: end" @click="closeRejectModal">close</v-icon>
          <div>
            <Typography center h2 bold label="ไม่อนุมัติ" />
          </div>
          <div class="rsu mt-2">
            <v-layout wrap class="mb-3">
              <v-flex xs12>
                <Typography center h5 label="คุณแน่ใจหรือไม่ว่าต้องการไม่อนุมัติคำขอนี้ (จะคงค่ายินยอมเดิมไว้)" />
              </v-flex>
            </v-layout>
            <div class="reasonBox mb-3">
              <Typography h6 bold label="เหตุผลที่ไม่อนุมัติ" class="mb-2" />
              <v-textarea
                v-model="rejectReason"
                placeholder="กรุณาระบุเหตุผลที่ไม่อนุมัติคำขอนี้"
                outlined
                no-resize
                auto-grow
                rows="3"
                hide-details
                class="depainputarea rsu mb-0"
              />
            </div>
            <div style="display: flex; justify-content: center">
              <Button :loading="deciding" outline label="ยกเลิก" @click="closeRejectModal" />
              <Button
                :loading="deciding"
                depressed
                label="ไม่อนุมัติ"
                @click="clickDecide('reject')"
              />
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="modalReason" width="450px">
      <v-card style="border-radius: 10px">
        <div class="pa-4">
          <v-icon style="display: flex;justify-content: end" @click="modalReason = false">close</v-icon>
          <div>
            <Typography center h2 bold label="เหตุผล" />
          </div>
          <div class="mt-3" style="max-height: 300px; overflow-y: auto; white-space: pre-line; word-break: break-word;">
            <Typography h5 :label="reasonText" />
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from '@/api'
import moment from 'moment'
import Typography from '@/components/elements/Typography.vue'
import Button from '@/components/elements/Button.vue'
import InputSearch from '@/components/elements/InputSearch.vue'

export default {
  components: {
    Typography,
    Button,
    InputSearch
  },
  data() {
    return {
      activeTab: 'privacy',
      isSearch: false,
      search: {
        nameAll: ''
      },
      headers: [
        { text: 'เลขสมาชิก', align: 'center', value: 'memberid' },
        { text: 'สมาชิก', align: 'center', value: 'name' },
        { text: 'รายการ / โครงการ', align: 'center', value: 'itemname' },
        { text: 'ค่าที่ขอ', align: 'center', value: 'value' },
        { text: 'วันที่ขอ', align: 'center', value: 'updated_at' },
        { text: 'เหตุผล', align: 'center', value: 'reason' },
        { text: '', align: 'center', value: '' }
      ],
      historyHeaders: [
        { text: 'วันที่/เวลา', align: 'center', value: 'timestamp' },
        { text: 'เลขสมาชิก', align: 'center', value: 'memberid' },
        { text: 'สมาชิก', align: 'center', value: 'membername' },
        { text: 'รายการ / โครงการ', align: 'center', value: 'itemname' },
        { text: 'คำขอ', align: 'center', value: 'requestedValue' },
        { text: 'เหตุผล', align: 'center', value: 'requestedReason' },
        { text: 'ผลการพิจารณา', align: 'center', value: 'decision' },
        { text: 'ผู้ดำเนินการ', align: 'center', value: 'adminid' },
        
      ],
      privacyData: [],
      projectData: [],
      historyData: [],
      loading: false,
      deciding: false,
      modalApprove: false,
      modalReject: false,
      modalItem: null,
      modalReason: false,
      reasonText: '',
      rejectReason: ''
    }
  },
  computed: {
    tabData() {
      return this.activeTab === 'privacy' ? this.privacyData : this.projectData
    },
    activeData() {
      const keyword = (this.search.nameAll || '').toLowerCase().trim()
      if (!keyword) return this.tabData
      return this.tabData.filter((item) => {
        return [item.memberid, item.name, item.institute_name, item.itemname]
          .filter(Boolean)
          .some((field) => String(field).toLowerCase().includes(keyword))
      })
    },
    activeHistoryData() {
      const keyword = (this.search.nameAll || '').toLowerCase().trim()
      if (!keyword) return this.historyData
      return this.historyData.filter((item) => {
        return [item.memberid, item.membername, item.itemname, item.adminid]
          .filter(Boolean)
          .some((field) => String(field).toLowerCase().includes(keyword))
      })
    }
  },
  async mounted() {
    await this.getPendingConsentRequests()
    await this.getConsentRequestHistory()
  },
  methods: {
    onSearch() {
      this.isSearch = !!(this.search.nameAll || '').trim()
    },
    clearSearch() {
      this.search.nameAll = ''
      this.isSearch = false
    },
    shotDate(input) {
      return input && moment(input).format('DD/MM/YYYY HH:mm')
    },
    privacyKeyLabel(key) {
      const labels = {
        INFORMATION: 'การให้ข้อมูล',
        PERSONAL_DATA: 'ข้อมูลส่วนบุคคล',
        BENEFITS: 'สิทธิประโยชน์'
      }
      return labels[key] || key
    },
    requestedValueLabel(requestedValue) {
      if (requestedValue === true) return 'ขอให้ความยินยอม'
      if (requestedValue === false) return 'ขอถอนความยินยอม'
      return '-'
    },
    viewReason(reason) {
      this.reasonText = reason || '-'
      this.modalReason = true
    },
    viewHistoryReason(item) {
      let text = `เหตุผลที่ขอ: ${item.requestedReason || '-'}`
      if (item.decision === 'reject') {
        text += `\n\nเหตุผลที่ไม่อนุมัติ: ${item.rejectReason || '-'}`
      }
      this.reasonText = text
      this.modalReason = true
    },
    closeRejectModal() {
      this.modalReject = false
      this.rejectReason = ''
    },
    notifyResultText(notify) {
      if (!notify) return ''
      if (notify.channel === 'email') return `แจ้งเตือนสมาชิกสำเร็จผ่านอีเมล ${notify.to}`
      if (notify.channel === 'phone') return `แจ้งเตือนสมาชิกสำเร็จผ่านเบอร์โทร ${notify.to}`
      return `ไม่สามารถแจ้งเตือนสมาชิกได้ (${notify.reason || 'ไม่พบช่องทางติดต่อ'})`
    },
    async getPendingConsentRequests() {
      this.loading = true
      try {
        const data = await api.getPendingConsentRequests()
        if (data) {
          this.privacyData = (data.privacy || []).map((item) => ({
            ...item,
            rowKey: `privacy-${item.key}-${item.memberid}`,
            itemname: this.privacyKeyLabel(item.key)
          }))
          this.projectData = (data.project || []).map((item) => ({
            ...item,
            rowKey: `project-${item.id}`,
            itemname: item.projectname
          }))
        }
      } catch (error) {
        console.error(error)
      }
      this.loading = false
    },
    async getConsentRequestHistory() {
      try {
        const data = await api.getConsentRequestHistory()
        if (data) {
          this.historyData = data.map((item) => ({
            ...item,
            rowKey: `history-${item.type}-${item.timestamp}-${item.memberid || item.adminid}`
          }))
        }
      } catch (error) {
        console.error(error)
      }
    },
    async clickDecide(decision) {
      const item = this.modalItem
      if (!item) return
      if (decision === 'reject' && !(this.rejectReason || '').trim()) {
        this.$swal.fire({ icon: 'warning', title: 'กรุณาระบุเหตุผลที่ไม่อนุมัติ' })
        return
      }
      this.deciding = true
      try {
        const payload = {
          type: item.type,
          decision,
          key: item.type === 'privacy' ? item.key : undefined,
          memberid: item.type === 'privacy' ? item.memberid : undefined,
          id: item.type === 'project' ? item.id : undefined,
          reason: decision === 'reject' ? this.rejectReason : undefined
        }
        const res = await api.decideConsentRequest(payload)
        if (res && res.responsecode === 200) {
          this.modalApprove = false
          this.modalReject = false
          this.modalItem = null
          this.rejectReason = ''
          await this.getPendingConsentRequests()
          await this.getConsentRequestHistory()
          this.$swal.fire({
            type: 'success',
            title: '<div class="headline primary--text bold7 fs-24">ทำรายการสำเร็จ</div>',
            text: this.notifyResultText(res.notify),
            confirmButtonText: '<span style="color:#FFEF01">ปิด</span>'
          })
        }
      } catch (error) {
        console.error(error)
      }
      this.deciding = false
    }
  }
}
</script>

<style lang="scss" scoped>
.reasonBox {
  background: #f5f7fa;
  border-radius: 10px;
  padding: 16px;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/view/consentApprove/main.vue